// src/utils/firestoreUtils.js

import { db } from '@/firebase/init'; // Adjust this path based on your actual Firebase setup

/**
 * Get Firestore document references for a given UID in order:
 * UID_dup2, UID_dup3, ..., UID
 *
 * @param {string} uid - The user ID
 * @returns {Promise<Array>} - Ordered array of Firestore document references
 */
export async function getOrderedHostingDocs(uid) {
  const docRefs = [];
  const baseRef = db.collection('hostingAccounts');
  let index = 2;

  while (true) {
    const dupRef = baseRef.doc(`${uid}_dup${index}`);
    const snap = await dupRef.get();
    if (snap.exists) {
      docRefs.push(dupRef);
      index++;
    } else {
      break;
    }
  }

  docRefs.push(baseRef.doc(uid)); // Main UID doc goes last (most recent)
  return docRefs;
}

/**
 * Determine if the UID is part of multi-doc users
 *
 * @param {string} uid
 * @returns {boolean}
 */
export function isMultiDocUser(uid) {
  const multiDocUIDs = [
    "KHLq1RjrpMT7aV0JY9fy2yrcYvT2",
    "N7uJSabGN5dLUlndus5rTUkpiW23",
    'uUNvXYtlKBU7XX5Kzm4gG0aM9ZK2'
  ];
  return multiDocUIDs.includes(uid);
}

/**
 * Get Firestore domain documents for a given UID in order:
 * UID_dup2, UID_dup3, ..., UID
 *
 * @param {string} uid
 * @returns {Promise<Array>} - Array of Firestore DocumentSnapshots
 */
export async function getOrderedDomainDocs(uid) {
  const docs = [];
  const baseRef = db.collection('domains');
  let index = 2;

  // Fetch _dupN docs first
  while (true) {
    const dupQuery = await baseRef.where('uid', '==', `${uid}_dup${index}`).get();
    if (!dupQuery.empty) {
      docs.push(...dupQuery.docs);
      index++;
    } else {
      break;
    }
  }

  // Fetch main UID last
  const mainQuery = await baseRef.where('uid', '==', uid).get();
  if (!mainQuery.empty) {
    docs.push(...mainQuery.docs);
  }

  return docs;
}